import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-finite.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
export var PRICE_UNITS = {
  FLAT: 'flat',
  SQUARE_METER: 'squareMeter'
};
export default /*#__PURE__*/_defineComponent({
  __name: 'PriceOutput',
  props: {
    input: null,
    unit: {
      default: PRICE_UNITS.FLAT
    },
    empty: {
      default: 'Неизвестно'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var output = computed(function () {
      var num = Number(props.input);
      if (Number.isFinite(num)) {
        return num.toLocaleString('ru-RU', {
          style: 'currency',
          currency: 'RUB',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        });
      }
      return props.empty;
    });
    var isSquareMeter = computed(function () {
      return props.unit === PRICE_UNITS.SQUARE_METER;
    });
    return {
      __sfc: true,
      PRICE_UNITS: PRICE_UNITS,
      props: props,
      output: output,
      isSquareMeter: isSquareMeter
    };
  }
});